import React, { useEffect, useState } from "react";
import { AppstoreFilled } from "@ant-design/icons";
import Icon from "@ant-design/icons/lib/components/Icon";
import { Dropdown, Menu } from "antd";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { clearCandidateSearchFilter } from "@redux/actionCreators";
import { getCurrentUserRole } from "@redux/actionCreators/siteList";
import {
  clearBookingSearchCandidate,
  clearVerifyBookingCandidate
} from "@redux/actionCreators/candidate";

import Auth from "config/auth";
import constants from "@constants/constants";
import ROLES from "@constants/roles";
import subHeaderMenu from "../sub-header/sub-header-data";

const { AGENCY_ADMIN } = ROLES;

const {
  PAGE_ROUTES: { CANDIDATE_LISTING_ROUTE }
} = constants;

const DropDownMenu = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [currentRole, setCurrentRole] = useState();
  const authData = Auth.getSessionDetails();
  const { currentUserRole } = authData;

  const saveRoleForUniqueTab = role => {
    sessionStorage.setItem("uniqueTabRole", role);
  };

  useEffect(() => {
    const uniqueTabRole = sessionStorage.getItem("uniqueTabRole");
    if (!uniqueTabRole || uniqueTabRole === "null") {
      const activeRole = localStorage.getItem("role");
      saveRoleForUniqueTab(activeRole);
    }
  }, []);

  const changeTab = ({ key }) => {
    dispatch(clearCandidateSearchFilter());
    dispatch(clearBookingSearchCandidate());
    dispatch(clearVerifyBookingCandidate());

    const platform = subHeaderMenu.find(item => item.name === key);
    const role = platform?.name ?? AGENCY_ADMIN;
    const route = platform?.navigateTo ?? CANDIDATE_LISTING_ROUTE;

    localStorage.setItem("role", role);
    saveRoleForUniqueTab(role);
    setCurrentRole(role);
    localStorage.removeItem("monthlyCalendar");
    navigate(route);
  };

  useEffect(() => {
    const role = localStorage.getItem("role") || currentUserRole;
    setCurrentRole(role);
    dispatch(getCurrentUserRole(role));
  }, [currentRole]);

  const menu = () => (
    <Menu onClick={changeTab}>
      {subHeaderMenu.map(({ name, icon, disabled }) => (
        <Menu.Item
          key={name}
          icon={<Icon component={icon} className="sub-nav-menu-icon" />}
          disabled={disabled}
        >
          {name}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown overlay={menu}>
      <AppstoreFilled
        style={{
          color: "white",
          fontSize: "22px",
          cursor: "pointer",
          display: "flow"
        }}
      />
    </Dropdown>
  );
};

export default React.memo(DropDownMenu);
